export default function getQuantityParam(): number | null {
  const queryString = window.location.search;
  const quantity = new URLSearchParams(queryString).get("quantity");

  if (quantity) {
    return Number(quantity);
  }

  return null;
}
